import React from "react";
import ServiceDetailsContainer from "../../containers/ManageServiceUsersMobileContainer/ServiceDetailsContainer";

export default function ServiceDetailsPage(props: any) {
  return (
    <ServiceDetailsContainer collapsed={props.collapsed} match={props.match} />
  );
}
